export default "__VITE_ASSET__BR41_Pl5__"